import { CategoryTree } from '../../../../redux/store/api/api';
import { ArticleType } from '../../../../shared/enums';
import {
  getArticleUrl,
  getCategoryReferenceUrl,
} from '../../../../shared/urlBuilder';
import { ContentSuggestionValue } from './ContentSuggestionValue';

type ArticleIconClass = 'icon-artikel' | 'icon-artikel_pdf' | 'icon-struktur';

function getArticleIcon(type: ArticleType): ArticleIconClass {
  let iconClass: ArticleIconClass = 'icon-artikel';

  if (type === ArticleType.Pdf) {
    iconClass = 'icon-artikel_pdf';
  }

  if (type === ArticleType.StructureElement) {
    iconClass = 'icon-struktur';
  }

  return iconClass;
}

export function toContentSuggestions(tree: CategoryTree) {
  const suggestions: ContentSuggestionValue[] = [];

  tree.categories
    ?.filter((category) => !category.disabled)
    .forEach((category) => {
      suggestions.push({
        treeElement: {
          id: category.id ?? '',
          href: getCategoryReferenceUrl(category.id ?? ''),
          name: category.name ?? '',
          icon: category.categoryTypeIconClass ?? '',
          iconColorHexCode: category.categoryTypeColorHexCode ?? '',
        },
        treeElementParent: {
          abbreviation: category.abbreviation ?? '',
          icon: category.categoryTypeIconClass ?? '',
          iconColorHexCode: category.categoryTypeColorHexCode ?? '',
        },
      });

      const articlesUnderCategory = tree.articles?.filter(
        (article) =>
          article.categoryId === category.id &&
          article.type !== ArticleType.StructureElement &&
          !article.disabled,
      );

      articlesUnderCategory?.forEach((article) => {
        suggestions.push({
          treeElement: {
            id: article.id ?? '',
            href: getArticleUrl(article.id ?? ''),
            name: article.recentVersionTitle ?? '',
            icon: getArticleIcon(article.type ?? ArticleType.Html),
            iconColorHexCode: '',
          },
          treeElementParent: {
            abbreviation: category.abbreviation ?? '',
            icon: category.categoryTypeIconClass ?? '',
            iconColorHexCode: category.categoryTypeColorHexCode ?? '',
          },
        });
      });
    });

  return suggestions;
}

export default toContentSuggestions;
